import { render } from "./visitorLoseEfficacy.vue?vue&type=template&id=d81232bc&scoped=true&ts=true"
import script from "./visitorLoseEfficacy.vue?vue&type=script&lang=ts"
export * from "./visitorLoseEfficacy.vue?vue&type=script&lang=ts"

import "./visitorLoseEfficacy.vue?vue&type=style&index=0&id=d81232bc&scoped=true&lang=css"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d81232bc"]])

export default __exports__